// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"BackButton_BackButton__2GoYK"};